var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-template',{attrs:{"icon":"/illustration-no-results.svg","text":"Sorry, no returns found","additional-text":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }